import type { Messages } from "@userreason/js";
import i18n from "../i18n/i18n";

const messageKeys = [
    "close",
    "back",
    "next",
    "send",
    "sending",
    "retry",
    "progress",
    "progressOpen",
    "chooseRating",
    "sentNow",
    "chooseOne",
    "chooseAny",
    "chooseUpTo",
    "chooseExactly",
    "chooseRange",
    "selected",
    "selectedOf",
    "maxReached",
    "required",
    "optional",
    "ratingValue",
    "yourFeedback",
    "placeholder",
    "enterFeedback",
    "chooseAnswer",
    "chooseAtLeast",
    "answerOne",
    "thankYou",
    "received",
    "failed",
    "responseLimit",
    "discardTitle",
    "discardProgress",
    "discardAnswered",
    "discardText",
    "saved",
    "keepEditing",
    "discard",
    "rankTop",
    "rankHint",
    "enterDate",
    "notBefore",
    "notAfter",
    "enterEmail",
    "fillIn",
    "prefilled",
    "tickConsent",
    "start",
    "notNow",
    "neverAsk",
    "aboutMinutes",
    "underMinute",
    "questionCount",
    "startsSurvey",
    "you",
    "dictate",
    "stopDictation",
    "micStarting",
    "listening",
    "wrappingUp",
    "secondsLeft",
    "dictated",
    "undo",
    "micBlocked",
    "micAllow",
    "micSettings",
    "nothingHeard",
    "timeLimit",
    "characterLimit",
    "voiceUnavailable",
    "micContinue",
    "hideKeyboard"
] as const satisfies readonly (keyof Messages)[];

/** The SDK supplies other app languages; Uzbek uses the app's translation source. */
export function playerFeedbackMessages(locale: string): Partial<Messages> | undefined {
    if (locale !== "uz") return undefined;
    return Object.fromEntries(messageKeys.map((key) => [
        key,
        i18n.t(`userReason.${key}`, { lng: "uz" }),
    ]));
}
